export * from './DocMinusIcon';
export * from './DocMinusIcon16Light';
export * from './DocMinusIcon16Regular';
export * from './DocMinusIcon16Solid';
export * from './DocMinusIcon20Light';
export * from './DocMinusIcon20Regular';
export * from './DocMinusIcon20Solid';
export * from './DocMinusIcon24Regular';
export * from './DocMinusIcon24Solid';
export * from './DocMinusIcon32Regular';
export * from './DocMinusIcon64Regular';
